import React, {useContext} from 'react';
import PatientListPageTemplate from "../../../../components/Templates/PatientListPageTemplate";
import {useParams} from "react-router-dom";
import OrgPatientListStore from "../../../../components/Modals/PrintModal/store/OrgPatientListStore";
import IconCell from "../../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";
import {AuthContext} from "../../../../context/AuthContext";
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {formatDate, isWaiting} from "../../../../utils/utils";


function HistoryPatients() {
    const {verCenterId, verCenterName, medId, medName, orgId, orgName, historyId, historyName} = useParams()

    const { token } = useContext(AuthContext)

    const url = `/api/v2/systemManagers/${token.userId}/verificationCenters/${verCenterId}/medCenters/${medId}/organizations/${orgId}/histories/${historyId}/patients?`

    const {REACT_APP_URL_PREFIX} = process.env

    const breadCrumbsItems = [
        {title: 'Контрагенты'},
        {title: 'Удостоверяющие центры',  link: process.env.REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters`},

        {
            title: verCenterName,
            link: REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters/${verCenterId}/${verCenterName}/medCenters`
        },
        {
            title: medName,
            link: REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters/${verCenterId}/${verCenterName}/medCentres/${medId}/${medName}/organizations`
        },
        {
            title: orgName,
            link: REACT_APP_URL_PREFIX + `/counterAgents/verificationCenters/${verCenterId}/${verCenterName}/medCentres/${medId}/${medName}/organizations/${orgId}/${orgName}/history`
        },
        {title: historyName,  actual: true},
    ]

    const printCell = props => {
        const showModal = (resultId, patientId ) => OrgPatientListStore.showPrintModal(resultId, patientId)
        const patientId = props.all?.patient_info?.id
        const resultId = props.all.id
        return !isWaiting(props?.all?.result) ? <IconCell iconName={'printer'} onClick={_ => showModal(resultId, patientId)}/> : ""
    }
    tableModel.haveToShow[5].typeData.cell = printCell
    return (
        <PatientListPageTemplate filterFieldsConf={{
            fio: true,
            date: true,
            period: true,
            org: true,
            medBook: true,
            center: true,
            result: true,
        }} tableModel={tableModel} getPatientURL={url} breadCrumbsItems={breadCrumbsItems} printall={true}/>
    );
}

export default HistoryPatients;

var tableModel = {
    firstRow: [
        {title: 'ФИО', id: 'fio',},
        {title: 'Дата рождения', id: 'dob',},
        {title: 'Мед. книжка', id: 'med_book',},
        {title: 'Дата прохождения', id: 'result_date',},
        {title: 'Результат', id: 'result',},
        {title: 'Распечатать', id: ''}],

    haveToShow: [
        {id: 'patient_info', type: 'arrCell', typeData: {show: 'fio', id: 'id'}},
        {id: 'patient_info', type: 'arrCell', typeData: {show: 'dob', id: 'id'}},
        {id: 'patient_info', type: 'arrCell', typeData: {show: 'med_book', id: 'id'}},
        {id: 'result_date', type: "wrapperCell", typeData: {cell: props => <LinkCell3 linkTitle={formatDate(props.cellContent)}/>}},
        {id: 'result', type: 'resultStatusCell'},
        {id: 'patient_info', idArr: ['id'], type: 'wrapperCell', typeData: {cell: () => {}}},
    ],
}